import { Checkbox, Typography } from 'antd'
import { FormikProps, FormikValues } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface CheckboxEmittedProps {
  formikProps: FormikProps<FormikValues>
}

export function CheckboxEmitted({ formikProps }: CheckboxEmittedProps) {
  const { t } = useTranslation()
  return (
    <>
      <Typography.Text>
        {t('web.report.6.emitted')} {': '}
      </Typography.Text>
      <Checkbox
        defaultChecked={false}
        onChange={e => {
          formikProps.setFieldValue?.('emitted', e.target.checked)
        }}
      />
    </>
  )
}
